import { axiosInstance } from "../services/axiosInstance";
import catchAsync from "../utils/catchAsync";


export const getAllCommission = catchAsync(async (teamMemberId) => {
  const { data } = await axiosInstance.get(`salon/team-member/${teamMemberId}/commission-team-member`);
  return data;
});

export const addCommission = catchAsync(async (teamMemberId, body) => {
  const { data } = await axiosInstance.post(`salon/team-member/${teamMemberId}/commission-team-member`, body);
  return data;
});

export const deleteCommission = catchAsync(async (teamMemberId, commissionId) => {
  const { data } = await axiosInstance.delete(`salon/team-member/${teamMemberId}/commission-team-member/${commissionId}`);
  return data;
});

export const updateCommission = catchAsync(async (teamMemberId, commissionId, body) => {
  const { data } = await axiosInstance.put(`salon/team-member/${teamMemberId}/commission-team-member/${commissionId}`, body);
  return data;
});

